import React, { useState, useEffect } from "react";
import { Container } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { FaArrowLeft, FaArrowUp, FaDownload } from "react-icons/fa";
import AOS from "aos";
import "aos/dist/aos.css";
import NavbarMenu from "../heroSection/NavbarMenu";
import Footer from "../footer/Footer";
import "./DriverTerms.css";
import SEO from "../SEO";

export default function TransportConditions() {
  const { t } = useTranslation();
  const [showScrollTop, setShowScrollTop] = useState(false);

  useEffect(() => {
    AOS.init({ once: true, duration: 1000, offset: 120 });
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      setShowScrollTop(window.scrollY > 400);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const sections = [
    {
      number: "1",
      title: t("transportConditions.s1.title"),
      content: (
        <>
          <p>{t("transportConditions.s1.p1")}</p>
          <p>{t("transportConditions.s1.p2")}</p>
        </>
      ),
    },
    {
      number: "2",
      title: t("transportConditions.s2.title"),
      content: (
        <>
          <p>{t("transportConditions.s2.p1")}</p>
          <ul>
            <li>{t("transportConditions.s2.l1")}</li>
            <li>{t("transportConditions.s2.l2")}</li>
            <li>{t("transportConditions.s2.l3")}</li>
            <li>{t("transportConditions.s2.l4")}</li>
            <li>{t("transportConditions.s2.l5")}</li>
            <li>{t("transportConditions.s2.l6")}</li>
          </ul>
          <p>{t("transportConditions.s2.p2")}</p>
        </>
      ),
    },
    {
      number: "3",
      title: t("transportConditions.s3.title"),
      content: (
        <>
          <p>{t("transportConditions.s3.p1")}</p>
          <p>{t("transportConditions.s3.p2")}</p>
          <ul>
            <li>{t("transportConditions.s3.l1")}</li>
            <li>{t("transportConditions.s3.l2")}</li>
            <li>{t("transportConditions.s3.l3")}</li>
            <li>{t("transportConditions.s3.l4")}</li>
            <li>{t("transportConditions.s3.l5")}</li>
            <li>{t("transportConditions.s3.l6")}</li>
          </ul>
        </>
      ),
    },
    {
      number: "4",
      title: t("transportConditions.s4.title"),
      content: (
        <>
          <p>{t("transportConditions.s4.p1")}</p>
          <p>{t("transportConditions.s4.p2")}</p>
          <ul>
            <li>{t("transportConditions.s4.l1")}</li>
            <li>{t("transportConditions.s4.l2")}</li>
            <li>{t("transportConditions.s4.l3")}</li>
          </ul>
          <p className="terms-warning">{t("transportConditions.s4.penalty")}</p>
        </>
      ),
    },
    {
      number: "5",
      title: t("transportConditions.s5.title"),
      content: (
        <>
          <p>{t("transportConditions.s5.p1")}</p>
          <p>{t("transportConditions.s5.p2")}</p>
          <p>{t("transportConditions.s5.p3")}</p>
        </>
      ),
    },
    {
      number: "6",
      title: t("transportConditions.s6.title"),
      content: (
        <>
          <p>{t("transportConditions.s6.p1")}</p>
          <p>{t("transportConditions.s6.p2")}</p>
          <ul>
            <li>{t("transportConditions.s6.l1")}</li>
            <li>{t("transportConditions.s6.l2")}</li>
            <li>{t("transportConditions.s6.l3")}</li>
          </ul>
          <p>{t("transportConditions.s6.p3")}</p>
          <p>{t("transportConditions.s6.p4")}</p>
        </>
      ),
    },
    {
      number: "7",
      title: t("transportConditions.s7.title"),
      content: (
        <>
          <p>{t("transportConditions.s7.p1")}</p>
          <p>{t("transportConditions.s7.p2")}</p>
          <p>{t("transportConditions.s7.p3")}</p>
        </>
      ),
    },
    {
      number: "8",
      title: t("transportConditions.s8.title"),
      content: (
        <>
          <p>{t("transportConditions.s8.p1")}</p>
          <ul>
            <li>{t("transportConditions.s8.l1")}</li>
            <li>{t("transportConditions.s8.l2")}</li>
            <li>{t("transportConditions.s8.l3")}</li>
            <li>{t("transportConditions.s8.l4")}</li>
          </ul>
        </>
      ),
    },
    {
      number: "9",
      title: t("transportConditions.s9.title"),
      content: (
        <>
          <p>{t("transportConditions.s9.p1")}</p>
          <p>{t("transportConditions.s9.p2")}</p>
          <p>{t("transportConditions.s9.p3")}</p>
        </>
      ),
    },
    {
      number: "10",
      title: t("transportConditions.s10.title"),
      content: <p>{t("transportConditions.s10.p1")}</p>,
    },
    {
      number: "11",
      title: t("transportConditions.s11.title"),
      content: (
        <>
          <p>{t("transportConditions.s11.p1")}</p>
          <p>{t("transportConditions.s11.p2")}</p>
          <p>{t("transportConditions.s11.p3")}</p>
          <p>{t("transportConditions.s11.p4")}</p>
          <p>{t("transportConditions.s11.p5")}</p>
        </>
      ),
    },
    {
      number: "12",
      title: t("transportConditions.s12.title"),
      content: (
        <>
          <p>{t("transportConditions.s12.p1")}</p>
          <p>{t("transportConditions.s12.p2")}</p>
          <p>{t("transportConditions.s12.p3")}</p>
        </>
      ),
    },
    {
      number: "13",
      title: t("transportConditions.s13.title"),
      content: (
        <>
          <p>{t("transportConditions.s13.p1")}</p>
          <p>{t("transportConditions.s13.p2")}</p>
        </>
      ),
    },
    {
      number: "14",
      title: t("transportConditions.s14.title"),
      content: (
        <>
          <p>{t("transportConditions.s14.p1")}</p>
          <ul>
            <li>{t("transportConditions.s14.l1")}</li>
            <li>{t("transportConditions.s14.l2")}</li>
            <li>{t("transportConditions.s14.l3")}</li>
            <li>{t("transportConditions.s14.l4")}</li>
            <li>{t("transportConditions.s14.l5")}</li>
            <li>{t("transportConditions.s14.l6")}</li>
          </ul>
        </>
      ),
    },
    {
      number: "15",
      title: t("transportConditions.s15.title"),
      content: (
        <>
          <p>{t("transportConditions.s15.p1")}</p>
          <p>{t("transportConditions.s15.p2")}</p>
        </>
      ),
    },
  ];

  return (
    <>
      <SEO
        title="TransCirox – Vertragsbedingungen für Transportaufträge"
        description="Vertragsbedingungen für Transportaufträge der TransCiroX GmbH für Transportpartner und Fahrer."
        keywords="Vertragsbedingungen, Transportaufträge, Transportpartner, Fahrer, TransCiroX"
      />
      <NavbarMenu />

      <section className="driver-terms-page mt-5 px-5">
        <Container>
          <div className="terms-card">
            {/* Header */}
            <div className="terms-header">
              <button className="back-btn" onClick={() => window.history.back()}>
                <FaArrowLeft />
              </button>
              <div>
                <h2>{t("transportConditions.title")}</h2>
              </div>
            </div>

            {/* Scroll Content */}
            <div className="terms-scroll">
              <div className="document">
                <h1>
                  {t("transportConditions.mainTitle")}
                  <br />
                </h1>
                <p>{t("transportConditions.company")}</p>
                {/* <h1>
                  {t("transportConditions.subtitle")}
                  <br />
                </h1> */}

                <hr />

                {sections.map((section) => (
                  <div key={section.number} className="document-section">
                    <h3>
                      {section.number}. {section.title}
                    </h3>
                    <div>{section.content}</div>
                    <hr />
                  </div>
                ))}

                {/* Footer */}
                <div className="document-meta">
                  <p>
                    {t("transportConditions.company")}<br />
                    {t("transportConditions.address")}<br />
                    {t("transportConditions.country")}
                  </p>
                  <p>{t("transportConditions.email")}: <a href="mailto:kontakt@transcirox.com">kontakt@transcirox.com</a></p>
                  <p>{t("transportConditions.website")}: <a href="https://www.transcirox.com">www.transcirox.com</a></p>
                </div>
              </div>
            </div>
          </div>
        </Container>
      </section>

      {/* Back to top button */}
      {showScrollTop && (
        <button
          className="back-to-top"
          onClick={scrollToTop}
          aria-label="Back to top"
        >
          <FaArrowUp />
        </button>
      )}

      <Footer />
    </>
  );
}